import { render, staticRenderFns } from "./ModalEditarRevisao.vue?vue&type=template&id=bd2c975e&scoped=true"
import script from "./ModalEditarRevisao.vue?vue&type=script&lang=js"
export * from "./ModalEditarRevisao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2c975e",
  null
  
)

export default component.exports